import React from 'react'
import Image from '~/components/core/Image'

const ImageSlice = ({ data, isProject }) => {
  return (
    <div>
      <div
        className={`col-12 lg-col-6 paragraph ${isProject ? 'lg-col-offset-1' : 'lg-col-offset-2'}`}
      >
        {data.titleContent && (
          <h2 className="title-block text-blue">{data.titleContent}</h2>
        )}

        {data.link ? (
          <a
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="open link"
          >
            <Image
              classes="w-full"
              width="950"
              maxWidth={true}
              sizes={{ 415: [415], 767: [767], 1023: [1023] }}
              image={data.image}
            />
          </a>
        ) : (
          <Image
            classes="w-full"
            width="950"
            maxWidth={true}
            sizes={{ 415: [415], 767: [767], 1023: [1023] }}
            image={data.image}
          />
        )}
      </div>
    </div>
  )
}

export default ImageSlice
